@if (editMode) {
  <div>
    <div class="col">
      <rask-textarea label="Kommentar" [rows]="8" [maxlength]="2000" [ngModel]="comment" (ngModelChange)="changeComment($event)" class="w-100"></rask-textarea>
    </div>
    <div class="col pb-5 pt-3">
      <div class="d-inline float-end">
        <rask-button color="primary" (click)="save()" [disabled]="!isEdited">Spara</rask-button>
        <rask-button color="secondary" (click)="abort()">Avbryt</rask-button>
      </div>
    </div>
  </div>
}
@if (!editMode) {
  <div>
    <div class="col pt-3">
      {{comment}}
    </div>
    <div class="col pb-5 pt-3">
      <div class="d-inline float-end">
        <rask-button color="primary" (click)="close()">Stäng</rask-button>
      </div>
    </div>
  </div>
}
